import React, { useState } from 'react'

import PropTypes from 'prop-types'

import './features25.css'

const Features25 = (props) => {
  const [activeTab, setActiveTab] = useState(0)
  return (
    <div className="thq-section-padding">
      <div className="features25-container1 thq-section-max-width">
        <div className="features25-tabs-menu">
          <div
            onClick={() => setActiveTab(0)}
            className="features25-tab-horizontal"
          >
            <div className="features25-divider-container">
              {activeTab === 0 && <div className="features25-container2"></div>}
            </div>
            <div className="features25-content">
              <h2 className="thq-heading-2">{props.feature1Title}</h2>
              <span className="thq-body-small">
                {props.feature1Description}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(1)}
            className="features25-tab-horizontal1"
          >
            <div className="features25-divider-container1">
              {activeTab === 1 && <div className="features25-container3"></div>}
            </div>
            <div className="features25-content1">
              <span className="thq-body-small">
                {props.feature2Description}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(2)}
            className="features25-tab-horizontal2"
          >
            <div className="features25-divider-container2">
              {activeTab === 2 && <div className="features25-container4"></div>}
            </div>
            <div className="features25-content2">
              <h2 className="thq-heading-2">{props.feature3Title}</h2>
              <span className="thq-body-small">
                {props.feature3Description}
              </span>
            </div>
          </div>
        </div>
        <div className="features25-image-container">
          {activeTab === 0 && (
            <img
              alt={props.feature1ImgAlt}
              src="https://images.unsplash.com/photo-1524785281156-c3c68d1e03c5?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDIwfHxjaGFrcmF8ZW58MHx8fHwxNzIwMjgwMTExfDA&amp;ixlib=rb-4.0.3&amp;w=1400"
              className="features25-image thq-img-ratio-16-9"
            />
          )}
          {activeTab === 1 && (
            <img
              alt={props.feature2ImgAlt}
              src={props.feature2ImgSrc}
              className="features25-image1 thq-img-ratio-16-9"
            />
          )}
          {activeTab === 2 && (
            <img
              alt={props.feature3ImgAlt}
              src={props.feature3ImgSrc}
              className="features25-image2 thq-img-ratio-16-9"
            />
          )}
        </div>
      </div>
    </div>
  )
}

Features25.defaultProps = {
  feature3Description:
    '„Co sudičky přály nám“, aneb numerologie dokáže odhalit vaše silné i slabé stránky na základě vašeho data narození. To v kombinaci s křestním jménem dokáže určit dispozice a progres vašeho osudu. Numerologie vám poslouží k vlastnímu sebepoznání, abyste se lépe vyznali sami v sobě a ve svém životě.',
  feature1ImgSrc:
    'https://images.unsplash.com/photo-1619865105948-0b5ca3f5a2d9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0MXw&ixlib=rb-4.0.3&q=80&w=1080',
  feature1Title: '🔮 Personalizované numerologické výklady',
  feature2ImgSrc:
    'https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0Mnw&ixlib=rb-4.0.3&q=80&w=1080',
  feature2Description:
    'Pracuji s kyvadlem, které slouží pro vysílání a přijímání energie, a tělovými svíčkami pro odhalení zdravotních potíží. Seznámím vás s vašimi čakrami a sestavím pro vás čakroskop.',
  feature3Title: 'Co je numerologie',
  feature2Title: 'Další služby',
  feature3ImgSrc:
    'https://images.unsplash.com/photo-1607624723856-d81428faa9ac?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0Mnw&ixlib=rb-4.0.3&q=80&w=1080',
  imageSrc:
    'https://images.unsplash.com/photo-1619865105948-0b5ca3f5a2d9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0MXw&ixlib=rb-4.0.3&q=80&w=1400',
  feature2ImgAlt: 'Compatibility Reports Image',
  feature1Description:
    'Získejte podrobné numerologické výklady přizpůsobené vašim konkrétním potřebám a otázkám.',
  feature3ImgAlt: 'Life Path Analysis Image',
  feature1ImgAlt: 'Numerology Readings Image',
}

Features25.propTypes = {
  feature3Description: PropTypes.string,
  feature1ImgSrc: PropTypes.string,
  feature1Title: PropTypes.string,
  feature2ImgSrc: PropTypes.string,
  feature2Description: PropTypes.string,
  feature3Title: PropTypes.string,
  feature2Title: PropTypes.string,
  feature3ImgSrc: PropTypes.string,
  imageSrc: PropTypes.string,
  feature2ImgAlt: PropTypes.string,
  feature1Description: PropTypes.string,
  feature3ImgAlt: PropTypes.string,
  feature1ImgAlt: PropTypes.string,
}

export default Features25
